export default __webpack_public_path__ + "static/media/third-section.ec6e431b.png";